import { IconProps } from './type';

export const ICAllWorkOrder: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 128 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect
                x="26"
                y="22"
                width="64"
                height="78"
                rx="12"
                fill="#a797ff"
                opacity="0.45"
            />
            <rect
                x="34"
                y="16"
                width="64"
                height="86"
                rx="12"
                fill="#a797ff"
                opacity="0.75"
            />
            <rect x="42" y="26" width="64" height="82" rx="12" fill="#4f4b5c" />
            <rect x="58" y="18" width="32" height="16" rx="7" fill="#a797ff" />
            <rect x="56" y="48" width="36" height="7" rx="3.5" fill="#FF6B4A" />
            <rect x="56" y="64" width="28" height="6" rx="3" fill="#FF6B4A" />
            <rect x="56" y="78" width="34" height="6" rx="3" fill="#FF6B4A" />
            <circle cx="94" cy="92" r="18" fill="#a797ff" />
            <path
                d="M84 92H104"
                stroke="#4f4b5c"
                strokeWidth={5}
                strokeLinecap="round"
            />
            <path
                d="M94 82V102"
                stroke="#4f4b5c"
                strokeWidth={5}
                strokeLinecap="round"
            />
        </svg>
    );
};
